import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ClockIcon, CalendarIcon, SparklesIcon } from 'lucide-react';
export function FinancingBenefits() {
  const benefits = [{
    icon: ClockIcon,
    title: 'Easy & Quick to Apply',
    description: 'Simply apply online'
  }, {
    icon: CalendarIcon,
    title: 'Flexible Monthly Payment Options',
    description: 'Manage payments online'
  }, {
    icon: SparklesIcon,
    title: "Don't Wait to Look Great",
    description: "Get the treatments you've been wanting now & pay later"
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1232">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1233">
        <AnimateOnScroll data-id="element-1234">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-8" data-id="element-1235">
            {benefits.map((benefit, index) => <div key={index} className="bg-white rounded-xl p-8 lg:p-10 flex flex-col items-center text-center shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-transform hover:-translate-y-1 duration-300" data-id="element-1236">
                <benefit.icon className="text-[#FF1493] mb-6" size={48} strokeWidth={1.5} data-id="element-1237" />
                <h3 className="text-black font-bold uppercase text-lg lg:text-xl mb-3 font-[Poppins,_sans-serif] leading-tight" data-id="element-1238">
                  {benefit.title}
                </h3>
                <p className="text-[#666666] text-base font-body" data-id="element-1239">
                  {benefit.description}
                </p>
              </div>)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}